<template>
<el-row type="flex" justify="center">
	<el-col :xs="24" :sm="12" :md="10" :lg="8">
		<el-form label-position="top" label-width="100px">
			<h1>Reset</h1>
			<p>Please enter your new password.</p>
			<hr>
			<el-form-item label="Password:">
				<el-input @input="$v.credentials.password.$touch()" placeholder="Password" type="password" v-model.trim="credentials.password" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.password.$error">
				<span class="el-form-item__error" v-if="!$v.credentials.password.required">Field is required.</span>
				<span class="el-form-item__error" v-if="!$v.credentials.password.minLength">Email must have at least {{$v.credentials.password.$params.minLength.min}} characters.</span>
				</span>
			</el-form-item>

			<el-form-item label="Repeat Password:">
				<el-input @input="$v.credentials.repeatPassword.$touch()" placeholder="Password" type="password" v-model.trim="credentials.repeatPassword" :disabled="app.isLoading"></el-input>
				<span v-if="$v.credentials.repeatPassword.$error">
				<span class="el-form-item__error" v-if="!$v.credentials.repeatPassword.required">Field is required.</span>
				<span class="el-form-item__error" v-if="!$v.credentials.repeatPassword.sameAsPassword">Passwords must be identical.</span>
				</span>
			</el-form-item>
			<hr>
			<p>
				<el-button type="button" @click="resetPassword()" :disabled="$v.$invalid || app.isLoading" :loading="app.isLoading">
					Reset Password
				</el-button>
			</p>
		</el-form>
	</el-col>
</el-row>
</template>

<script>
import {
	required,
	sameAs,
	minLength,
	email,
	alphaNum
} from "vuelidate/lib/validators";
import router from "@/router";
import axios from "axios";
import store from "@/utils/store";
import { RESET_CHECK_URL, RESET_URL } from "@/config";

export default {
	name: "reset",
	data() {
		return {
			app: store,
			credentials: {
				email: this.$route.query.email,
				token: this.$route.query.token,
				password: "",
				repeatPassword: ""
			}
		};
	},
	validations: {
		credentials: {
			email: {
				required,
				email
			},
			token: {
				required
			},
			password: {
				required,
				minLength: minLength(6)
			},
			repeatPassword: {
				required,
				sameAsPassword: sameAs("password")
			}
		}
	},
	computed: {
		validHash() {
			let _self = this;
			if (!this.credentials.email || !this.credentials.token)
				return false;
			axios
				.post(RESET_CHECK_URL, {
					email: this.credentials.email,
					token: this.credentials.token
				})
				.then(function(response) {
					return true;
				})
				.catch(function(error) {
					let res = error.response;
					router.push("/");
					return (_self.app.messages = [res.data.message]);
				});
		}
	},
	methods: {
		resetPassword() {
			if (this.$v.$invalid) return;
			let _self = this;
			axios
				.post(RESET_URL, {
					email: this.credentials.email,
					token: this.credentials.token,
					password: this.credentials.password,
					password_confirmation: this.credentials.repeatPassword
				})
				.then(function(response) {
					router.push("/");
					return (_self.app.messages = [response.data.message]);
				})
				.catch(function(error) {
					let res = error.response;
					return (_self.app.messages = [res.data.message]);
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// Reset.vue?7f10cb70